import { Injectable } from '@angular/core';  
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from './common.service';
import { AuthorizationService } from '../authorization.service';
@Injectable({ providedIn: 'root' })
  
export class AuthGuard implements CanActivate {

  inboundMenus = ['AppComponent','InboundComponent','ConsultationGridComponent','ReasoncodeComponent','CrossdockgridComponent','SupplierlistComponent','GriddetailsComponent','ModifycontractComponent','CrossdockdetailsComponent'];
  outboundMenus = ['AppComponent','OutboundComponent','SuppliersComponent','MasterComponent','PointoflegComponent','CompoundComponent','ServiceComponent','FuelindexComponent','LegComponent','LegdetailComponent','RouteComponent','BafComponent','VehiclesComponent','MissingtarrifComponent','CreatecontractComponent','ContractSearchComponent'];
  userRole = '';
  allowedForSupplier = ['supplier-group-details','company-details','site-details','logout'];
  constructor(private _router: Router, private apiService : CommonService,private authservice:AuthorizationService) {
    const RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);    
  }

  checkAllProfilesAndEnv(RoleByService: any){
    let c = RoleByService;
    if(c['userAccess']!=undefined && !c['userAccess'].includes('Deined')){
      this.userRole = c['role'];
    }else{
      this.userRole = 'norole';
    }
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url.split('/');

    let path = url[1];  
    if(path=='auth'){

    } else if(path=='logout'){
      this._router.navigate(['/logout']);

    } else{
      console.info("url",state.url);
      localStorage.setItem('currentUrl',state.url);
    }
    if(this.userRole!='Deined'){
    this.apiService.matomoCall(path,next.data.page_title);
    }
    if(this.userRole == 'supplier'){
      if(this.allowedForSupplier.indexOf(path) != -1){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
    
  }  
} 